import React from "react";
import ReactDOM from "react-dom";
import { Alert } from "@mui/material";
import { Routes } from "../../../root/routes";

const MailboxDisconnectedAlert = () => {
  return (
    <Alert
      severity="error"
      sx={{
        backgroundColor: "var(--color-red-200)",
        color: "var(--color-red-700)",
      }}
    >
      Oh no! It looks like your privacy email has been disconnected. Please visit your{" "}
      <a href={Routes.privacyCenter.privacyEmails} target="_blank" rel="noreferrer">
        privacy inbox settings
      </a>{" "}
      to reconnect it.
    </Alert>
  );
};

export const MailboxDisconnectedBanner = () => {
  const mount = document.getElementById("top-banner");
  return ReactDOM.createPortal(<MailboxDisconnectedAlert />, mount);
};
